export const HOST_APP_TITLE = '蜂之语运营平台'

export const HOST_APP_NAME = 'opApp' // 宿主应用名称

export const HOST_APP_DEFAULT_PROD_HOST = 'fzy-admin.tfengzy.com' // 默认生产域名
export const HOST_APP_DEFAULT_PROD_URL = `https://${HOST_APP_DEFAULT_PROD_HOST}` // 默认生产地址
export const HOST_APP_PROD_HOSTS = [HOST_APP_DEFAULT_PROD_HOST, 'kt.tuxi.net.cn']

export const HOST_APP_ZCAT_KEY = 'tuxi-operate-web'
export const HOST_APP_CNZZ_SCRIPT = 'https://s4.cnzz.com/z_stat.php?id=1280732172&web_id=1280732172'

/** 集成为应用名称 */
export const META_APP_NAMES = Object.freeze({
  DATA_CENTER: 'TuxiDataApp',
  DATA_CENTER2: 'TuxiDataApp2',
  CONFIG_CENTER: 'TuxiConfigApp',
  KDCS_OPERATE: 'KdcsOperateApp',
  AD_OPERATE: 'AdOperateApp',
  YLPT_OPERATE: 'YlptOperateApp',
  DMS_OPERATE: 'DmsOperateApp',
  IOT_OPERATE: 'IotOperateApp',
  ZSCMKDG_OPERATE: 'ZscmKdgOperateApp',
  ABOSS_OPERATE: 'ABossOperateApp'
})

/** 设置标准cookie编码，为iframe接入第三方应用（如数据中台） */
export const COOKIE_CODES = Object.freeze({
  DEPT_CODE: 'tuxi_dept_code', // 部门code, cookie key
  IAM_TOKEN: 'tuxi_iam_token', // iam token, cookie key
  PORTAL_ROLE_CODE: 'tuxi_portal_role_code', // 门户标识
  USER_POSITION_CODE: 'tuxi_user_dept_position', // 门户标识
  LINK_ID: 'tuxi_link_id', // 链路id
  DEVICE_ID: 'tuxi_device_id' // 设备id
})

/** 全局事件 */
export const GLOBAL_EVENTS = Object.freeze({
  CURRENT_APP_CHANGE: '$app_change',
  ANALYSIS_DATE_RANGE_CHANGE: '$analysis_date_range_change',
  OPEN_HELPER: '$open_helper',
  OPEN_CUSTOM_SERVICE: '$open_custom_service',
  OPEN_MENU_INTRO: '$open_menu_intro',
  AUDIT_SUBMITTED: '$app_audit_submitted'
})

export const HTTP_STATUS_CODES = Object.freeze({
  EMPTY_PARAM: 'S208', // 没有传必须参数
  IAM_TOKEN_EXPIRED: 'S217', // IAM Token过期
  SSO_TOKEN_EXPIRED: 'S205', // SSO Token过期
  JWT_TOKEN_INVALID: 'S209', // JWT Token无效
  SSO_ERROR: 'S218', // SSO系统错误
  INVALID_CODE: 'invalid_code', // 无效code
  USER_DISABLED: 'user_disabled' // 用户被禁用
})

/**
 * 请求编号，对特殊的请求进行编号，以进行特殊处理
 */
export const REQUEST_CODES = Object.freeze({
  TRACE: 'trace', // 买点接口
  AUTH_GET_USER_INFO: 'auth.getUserInfo' // 获取用户信息
})
